import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function Inquiries() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/inquiries").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/inquiries/${id}`);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this inquiry?")) return;
    await api.delete(`/inquiries/${id}`);
    setSelected(null);
    load();
  };

  return (
    <div data-testid="inquiries-admin">
      <p className="overline mb-2">Contact form</p>
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter mb-10">Inquiries</h1>

      {items.length === 0 ? (
        <div className="bg-[#121214] border border-white/5 p-12 text-center">
          <p className="text-[#8A8A93]">No inquiries yet.</p>
        </div>
      ) : (
        <div className="bg-[#121214] border border-white/5 divide-y divide-white/5">
          {items.map((it) => (
            <button
              key={it.id}
              onClick={() => {
                setSelected(it);
                if (!it.read) markRead(it.id);
              }}
              className="w-full text-left p-5 hover:bg-white/[0.02] transition-colors flex items-start gap-4"
            >
              <span className={`mt-2 w-2 h-2 rounded-full shrink-0 ${it.read ? "bg-white/10" : "bg-[#C9A050]"}`} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-4 mb-1">
                  <span className="font-medium text-white truncate">{it.name}</span>
                  <span className="text-xs text-[#8A8A93] shrink-0">{new Date(it.created_at).toLocaleDateString()}</span>
                </div>
                <p className="text-sm text-[#8A8A93] truncate">{it.email}{it.company && ` · ${it.company}`}</p>
                <p className="text-sm text-[#A1A1AA] mt-2 line-clamp-2">{it.message}</p>
              </div>
            </button>
          ))}
        </div>
      )}

      {selected && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur flex items-center justify-center p-6" onClick={() => setSelected(null)}>
          <div className="max-w-2xl w-full bg-[#0A0A0C] border border-white/10 p-8" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <p className="overline">Inquiry detail</p>
              <button onClick={() => setSelected(null)} className="overline text-[#8A8A93] hover:text-white">Close ×</button>
            </div>
            <h2 className="font-display text-3xl mb-2">{selected.name}</h2>
            <p className="text-[#8A8A93] mb-6">
              <a href={`mailto:${selected.email}`} className="hover:text-[#C9A050]">{selected.email}</a>
              {selected.company && ` · ${selected.company}`}
              {selected.budget && ` · ${selected.budget}`}
            </p>
            <p className="text-[#E4E4E7] leading-relaxed whitespace-pre-wrap">{selected.message}</p>
            <p className="text-xs text-[#8A8A93] mt-8">
              Received {new Date(selected.created_at).toLocaleString()}
            </p>
            <div className="mt-8 flex gap-3 pt-6 border-t border-white/5">
              <a href={`mailto:${selected.email}`} className="overline border border-[#C9A050] text-[#C9A050] hover:bg-[#C9A050] hover:text-black px-5 py-3 transition-all">Reply via email</a>
              <button onClick={() => remove(selected.id)} className="overline border border-red-500/30 text-red-400 hover:bg-red-500/10 px-5 py-3 transition-all">Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
